import React from "react";
import { HeaderNew } from "./HeaderNew";
import { MobileFooter } from "./MobileFooter";
import Footer from "./Footer";

export default function Index({ children, socket }) {
  return (
    <>
      <div className="container-fluid header relative z-5">
        <HeaderNew socket={socket} />
      </div>
      <div className="flex flex-column justify-content-between">
        <div className="main-container" style={{ minHeight: "80vh" }}>
          {children}
        </div>
        {/* Desktop Footer */}
        <footer className="hidden lg:block bg-slate-900 text-white py-5">
          <Footer />
        </footer>
        {/* Mobile Footer */}
        <div className="container-fluid bg-secondary bottom-0 block lg:hidden">
          <MobileFooter />
        </div>
      </div>
    </>
  );
}
